var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base",attrs:{"id":"app"}},[_c('background'),_c('transition',{attrs:{"name":"page"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }